import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document
	.querySelectorAll(".wp-block-internationalization-internationalization")
	.forEach((el) => {
		const root = el.querySelector(".internationalization__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
